import React from "react"

const NotFoundPage = () => (

    <p>404</p>

)

export default NotFoundPage
